import type { ErrorLike } from '@apollo/client';
import { CombinedGraphQLErrors } from '@apollo/client/errors';
import type { GraphQLFormattedError } from 'graphql';
import { first } from 'lodash';
import { Errors } from '../texts';
import { HttpError } from './HttpError';

export interface ErrorWithStatusCode {
  message: string;
  statusCode?: HttpError;
}

export const transformGraphqlError = (error: GraphQLFormattedError): ErrorWithStatusCode => {
  if ('extensions' in error) {
    return {
      message: error.message,
      statusCode: error.extensions?.code as HttpError,
    };
  }

  return { statusCode: HttpError.InternalServerError, message: error.message };
};

export const getGenericErrorFromApolloError = (error: ErrorLike): string => {
  const graphQLError = CombinedGraphQLErrors.is(error) ? first(error.errors) : undefined;

  if (graphQLError) {
    const errorDetails = transformGraphqlError(graphQLError);

    switch (errorDetails.statusCode) {
      case HttpError.Unauthorized:
      case HttpError.FileNotFound:
      case HttpError.Forbidden:
        return Errors.NoAccessToPage;

      case HttpError.InternalServerError:
      default:
        return Errors.SomethingWentWrongTryAgainLater;
    }
  } else {
    return Errors.SomethingWentWrongTryAgainLater;
  }
};
